import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';
import { forwardRef } from 'react';

import type { TamagoshiIcon } from '../../interfaces';

export const GiftIcon = forwardRef<SVGSVGElement, TamagoshiIcon>(
  (props, ref) => (
    <Svg
      optimizationId="tama-gift"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.318 8.727h2.864v2.455H4.636V8.727h3.682Zm4.5 0v2.455H19.364V8.727H12.818Zm5.452-1.636h1.912c.452 0 .818.366.818.818V12a.818.818 0 0 1-.818.818h-.818v7.364a.818.818 0 0 1-.819.818H5.456a.818.818 0 0 1-.819-.818v-7.364h-.818A.818.818 0 0 1 3 12V7.91c0-.453.366-.82.818-.82H5.73A2.864 2.864 0 0 1 8.318 3c1.605 0 2.8.956 3.632 2.47l.05.092.05-.093C12.882 3.956 14.077 3 15.682 3a2.864 2.864 0 0 1 2.588 4.09Zm-2.588 0a1.227 1.227 0 1 0 0-2.455c-.902 0-1.624.578-2.198 1.622a6.662 6.662 0 0 0-.383.833h2.58Zm-4.783 0h-2.58a1.227 1.227 0 0 1 0-2.455c.9 0 1.623.578 2.197 1.622.146.265.274.546.383.833Zm.283 5.727h-4.91v6.546h4.91v-6.546Zm1.636 6.546v-6.546h4.91v6.546h-4.91Z"
        fill="currentColor"
      />
    </Svg>
  ),
);

GiftIcon.displayName = 'GiftIcon';
